import { Component, Input, ViewChild, OnInit, ComponentRef } from '@angular/core';
import { WidgetBaseComponent } from '../../../report-designer/widgets/widgetBase';
import { LocalizationWidgetHostDirective } from './localization-widget-host.directive';
import { reportDesignerWigdets } from '../../../report-designer/widgets/widgetsRegistry';
import { HttpClient } from '@angular/common/http';
import { LocalizationService } from '../../services/localization-service';
import { DestroyBase } from '../../../../components/common/ng-destroy-base';
import { LocalizationNavigationService } from '../../services/localization-navigation-service';
import { take } from 'rxjs/operators';
import { widgetDefinitions } from '../../../report-designer/widgets-definitions';
import { AppServiceHelperService } from '../../../../services/app-service-helper.service';
import { AppLocalizationService } from '../../../../services/AppLocalizationService';
import { ReportDesignerStorageService } from '../../../report-designer/services/report-designer-storage.service';
import { ReportDesignerTranslatorService } from '../../../report-designer/services/report-designer-translator.service';

/**
 * Localization Widget component
 */
@Component({
  selector: 'localization-widget',
  templateUrl: './localization-widget.component.html',
  styleUrls: ['./localization-widget.component.css']
})
export class LocalizationWidgetComponent extends DestroyBase implements OnInit {
  /**
  * The widget name (f.e. keyFiguresWidget)
  */
  private _translationData: any;

  /**
   * Initialized?
   */
  private initializedOnce = false;

  /**
   * Translation data
   */
  @Input('translationData') set widgetName(value: any) {
    this._translationData = value;
    if (this.widgetJson) {
      this.reset();
      this.init();
    }
  }

  /**
   * Preview not available
   */
  public previewNotAvailable = true;

  /**
   * Widget JSON
   */
  private widgetJson: any = null;

  /**
   * Widget instance
   */
  private widgetInstance: ComponentRef<WidgetBaseComponent>;

  /**
   * Available layouts
   */
  public availableLayouts: string[] = null;

  /**
   * Selected layout
   */
  public selectedLayout: string;

  /**
 * The place where the dynamic component will be rendered
 */
  @ViewChild(LocalizationWidgetHostDirective, { static: true }) localizationWidgetHost: LocalizationWidgetHostDirective;

  /**
   * Constructor
   * @param http
   * @param localizationService
   * @param localizationNavigationService
   * @param appLocalization
   * @param rdStorage
   * @param reportDesignerTranslator
   * @param appServiceHelper
   */
  constructor(private http: HttpClient, public localizationService: LocalizationService,
    private localizationNavigationService: LocalizationNavigationService,
    private appLocalization: AppLocalizationService,
    private rdStorage: ReportDesignerStorageService,
    private reportDesignerTranslator: ReportDesignerTranslatorService,
    private appServiceHelper: AppServiceHelperService) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    const rdResorce = this.appServiceHelper.getServiceEndpoint('pollux.reportDesigner.api', 'widgets/translation/languagedefinitions/list?reportId=-1');

    this.rdStorage.setCurrencyDescription('€');
    this.rdStorage.setUnitOfLength('m');
    this.http.get(rdResorce).pipe(take(1)).subscribe((configurations: any[]) => {
      //set all defined languages in dataverse/config
      this.appLocalization.setAllReportDesignerDictionaryConfigurations(configurations);

      this.widgetJson = widgetDefinitions;
      this.reset();
      this.init();
    });

    this.subscriptions.add(this.localizationNavigationService._isTranslationUpdated.subscribe(() => {
      if (!this.initializedOnce) {
        return;
      }
      this.reset();
      this.init();
    }));
  }

  /**
   * Resets the component
   */
  private reset(): void {
    const viewContainerRef = this.localizationWidgetHost.viewContainerRef;
    viewContainerRef.clear();

    this.localizationService.setTranslationOverride(null);
  }

  /**
   * Layout change handler
   * @param newLayout
   */
  public onLayoutChanged(newLayout: string) {
    this.widgetInstance.instance.currentLayout = newLayout;
    if (this.widgetInstance.instance.ref) {
      this.widgetInstance.instance.ref.markForCheck();
    }
  }

  /**
   * Initialization logic
   * @returns
   */
  private init(): void {
    this.previewNotAvailable = true;
    const widgetNameComponentEntry = reportDesignerWigdets.find(en => en.dataverseName == this._translationData.name);
    const viewContainerRef = this.localizationWidgetHost.viewContainerRef;
    viewContainerRef.clear();

    this.localizationService.setTranslationOverride(this._translationData);

    if (widgetNameComponentEntry) {
      this.previewNotAvailable = false;

      const allWidgets = [];
      for (const category of this.widgetJson) {
        allWidgets.push(...category.items);
      }

      const componentRef = viewContainerRef.createComponent(widgetNameComponentEntry.componentClass);

      if (!(componentRef.instance instanceof WidgetBaseComponent)) {
        return;
      }
      this.reportDesignerTranslator.ready('all').then(() => {
        const widget = allWidgets.find(en => en.downgradedName === widgetNameComponentEntry.downgradedName);
        if (widget) {
          (componentRef.instance as WidgetBaseComponent).mockup = true;
          (componentRef.instance as WidgetBaseComponent).widgetConfig = widget.config;
          (componentRef.instance as WidgetBaseComponent).editMode = false;

          if (widget.config?.widgetSettings?.availableLayouts?.length > 0) {
            this.availableLayouts = widget.config.widgetSettings.availableLayouts;
            this.selectedLayout = widget.config.widgetSettings.currentLayout;
          } else {
            this.availableLayouts = null;
            this.selectedLayout = null;
          }
          this.widgetInstance = componentRef;

        }
        else {
          this.previewNotAvailable = true;
        }
        this.initializedOnce = true;
      });
    }
    else {
      this.previewNotAvailable = true;
      this.initializedOnce = true;
    }
  }
}
